import { getTripSettingsService } from '../../services/accountSettingsService';
import { applyPortalTextColor } from '../../utils/helper';

export async function getTripSettings(dispatch) {
    try {
        let response = await getTripSettingsService();

        if (response.data) {
            applyPortalTextColor(response.data.portalTextColor);
            dispatch({ type: 'GET_SETTINGS_SUCCESS', payload: response.data });
            return response.data;
        }
        dispatch({ type: 'GET_SETTINGS_ERROR', error: response.data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'GET_SETTINGS_ERROR', error: error });
    }
}
